module.exports = __webpack_public_path__ + "img/social.236ea99.jpg";